import React from "react";
import { t } from "@lingui/macro";
import { i18n } from "idc-ui-react";
// Fluent UI
import { Stack, Text, Spinner, Overlay } from "@fluentui/react";
// Our Modules
import { store } from "../../../../stores/Main";

export function ReportHTMLView({ fullPage = false }) {
  return (
    <Stack grow>
      {store.state.HTMLReport && (
        <iframe
          id="report"
          title="IDC Report"
          src={store.state.HTMLReport}
          height={
            fullPage ? window.innerHeight - 200 : window.innerHeight - 377
          }
          frameBorder="0"
          allow="clipboard-read; clipboard-write"
        ></iframe>
      )}
      {store.state.isFetchingReport && (
        <Overlay
          styles={{
            root: {
              backgroundColor: "rgba(255, 255, 255, 0.8)"
            }
          }}
        >
          <Stack
            horizontalAlign="center"
            verticalAlign="center"
            style={{ height: "100%" }}
          >
            <Spinner
              label={
                <Text>
                  <Text variant="smallPlus" block>
                    {i18n._(t`Fetching Report`)}
                  </Text>
                  <Text variant="smallPlus">
                    {i18n._(t`This may take a few minutes...`)}
                  </Text>
                </Text>
              }
            />
          </Stack>
        </Overlay>
      )}
    </Stack>
  );
}
